import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useFeedFeedStore = defineSmartFeedPiniaStore(
  "feed-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
    }),
    getters: {
      feedUrl() {
        return `/feeds/${this.filters[0].value}`;
      },
    },
  },
);
